// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatawmnt } from "../../../icons/mono/build/icon-statawmnt.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatawmntIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatawmnt.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatawmntIcon.displayName = 'StatawmntIcon';
}

export default StatawmntIcon;